import Header from "@/reusable_sections/Header";
import FrequentlyAskedQuestions from "./sections/FrequentlyAskedQuestions";
import Calltoaction from "./sections/Calltoaction";
import Footer from "@/reusable_sections/Footer";
export default function FrequentlyAskedQuestionsPage() {
  return <div>
      <Header />
      <FrequentlyAskedQuestions />
      <Calltoaction />
      <Footer />
    </div>;
}